import React, { useState, useEffect } from "react";
import API from '../api/index';

function ExperienceItem(from,to,title,company,location,index){
	return(
		<div class="content-item col-md-6" key={index}>
			<small>{from} - {to}</small>
			<h3>{title}</h3>
			<h4>{company}</h4>
			<p>{location}</p>
		</div>
	)
}

function Experience(){
	const [experienceData, setExperienceData] = useState([]);
	let count = 1;

	useEffect(() => {
		let expData = API.getExperience();
		expData.then(
			response => {
				setExperienceData(response.records)
				// console.log(response);
			}
		);
	}, [count]);

	return(
		<section class="section-wrapper section-experience gray-bg">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-12">
						<div class="section-title"><h2>Work Experience</h2></div>
					</div>
				</div>

				<div class="row">
					{
						experienceData	?	
							experienceData.map((item,index) => 
								ExperienceItem(item.fields.Start, item.fields.End, item.fields.Title, item.fields.Company, item.fields.Location, index)
							)
						:	<></>
					}
				</div>
			</div>

		</section>
	)
}

export default Experience;